import { render, staticRenderFns } from "./allGrouping.vue?vue&type=template&id=6122cf24&scoped=true&"
import script from "./allGrouping.vue?vue&type=script&lang=js&"
export * from "./allGrouping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6122cf24",
  null
  
)

export default component.exports